import { render, staticRenderFns } from "./KnIncomeCategories.vue?vue&type=template&id=6550b2f1"
import script from "./KnIncomeCategories.js?vue&type=script&lang=js&external"
export * from "./KnIncomeCategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports